"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Icon = _interopRequireDefault(require("../../../Icon"));

var _index = require("./index.styles"); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var Input = function Input(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.icon || props.handleClear ? /*#__PURE__*/_react["default"].createElement(_index.Wrapper, null, props.icon && /*#__PURE__*/_react["default"].createElement(_index.StyledIcon, {
    as: props.icon
  }), /*#__PURE__*/_react["default"].createElement(_index.StyledInput, props), props.handleClear && /*#__PURE__*/_react["default"].createElement(_index.StyledButton, {
    type: "button",
    title: props.clearTitle,
    onClick: props.handleClear
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    as: _index.StyledClearIcon
  }))) : /*#__PURE__*/_react["default"].createElement(_index.StyledInput, props));
};

Input.propTypes = {
  icon: (0, _propTypes.oneOfType)([_propTypes.element, _propTypes.node, _propTypes.object]),
  size: (0, _propTypes.oneOf)(['xs', 's', 'm', 'l', 'xl']),
  disabled: _propTypes.bool,
  handleClear: _propTypes.func,
  clearTitle: _propTypes.string
};
Input.defaultProps = {
  size: 'm',
  clearTitle: 'Leegmaken'
};
var _default = Input;
exports["default"] = _default;